export default __webpack_public_path__ + "a93234d88246d44e9a3cf906871e68a0.png";